module.exports = __webpack_public_path__ + "img/logo_green.07ec2c5e.png";